<template>
  <div class="mobile-tabs">
    <div class="tab-list">
      <div
        class="tab-item"
        v-for="(item, index) in tablist"
        :key="index"
        :class="index == current ? 'active' : ''"
        @click="change(index, item)"
      >
        <span class="label">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tabCurrent", "tablist"],
  computed: {
    current() {
      return this.tabCurrent;
    },
  },
  methods: {
    change(index, item) {
      if (item.status) {
        this.$emit("change", index);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mobile-tabs {
  background: white;
  padding: 15px;
  margin-bottom: 15px;

  .tab-list {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .tab-item {
      flex-shrink: 0;
      padding: 10px 20px;
      background: #f3f4f9;
      border-radius: 20px;
      font-size: 14px;
      color: #333;
      cursor: pointer;

      &.active {
        background: #0773fc;
        color: white;
      }
    }
  }
}
</style>
